import * as React from "react";
import { SVGProps } from "react";

const Vertcoin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1692 1709" {...props}>
    <g fillRule="evenodd">
      <path
        fill="#048657"
        d="M1440.08 245.48q-7.38-7.08-14.89-13.89L835 1057.36 609.49 766.77H242.41L139.25 885.43h191.93l458.24 598.14q22.94 21.79 45.58 21.79t43.19-21.79l724.54-1012.24q-6.29-13-13-25.75c65.72 121.51 103.08 260.91 103.08 409.11 0 472-378.95 854.7-846.41 854.7S0 1326.73 0 854.69 379 0 846.42 0c231.27 0 440.89 93.67 593.66 245.48Z"
      />
      <path
        fill="#fff"
        d="m139.25 885.43 103.16-118.66h367.08L835 1057.36l590.19-825.77q52.72 47.76 98.37 109a797.7 797.7 0 0 1 79.17 130.76L878.19 1483.57q-20.54 21.79-43.19 21.79t-45.58-21.79L331.18 885.43Z"
      />
    </g>
  </svg>
);

export default Vertcoin;
